import { Descriptions, Tag } from 'antd';
import { formatDateTime } from 'utils/formatDate';
import MenuItemsSection from './menu-items-section';
import BannersSection from './banners-section';

const ItemDetail = ({ item }) => {
  return (
    <div>
      <Descriptions column={1} bordered>
        <Descriptions.Item label="ID">{item.id}</Descriptions.Item>
        <Descriptions.Item label="Type">
          <Tag color="blue">{item.type}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Title">{item.title}</Descriptions.Item>
        <Descriptions.Item label="Description">
          {item.description}
        </Descriptions.Item>
        <Descriptions.Item label="Ordering">{item.ordering}</Descriptions.Item>
        <Descriptions.Item label="Active">
          {item.is_active ? <Tag color="green">Active</Tag> : <Tag>Inactive</Tag>}
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {formatDateTime(item.created_at)}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {formatDateTime(item.updated_at)}
        </Descriptions.Item>
      </Descriptions>

      {item.type === 'callout_card' && (
        <p className="text-sm text-gray-500 mt-4 pt-4 border-t">
          Callout card content is managed on the{' '}
          <a href={`/admin/home-widgets/${item.id}/edit`}>Edit</a> page.
        </p>
      )}
      {item.type === 'menu' && <MenuItemsSection homeWidgetId={item.id} />}
      {item.type === 'banners' && <BannersSection homeWidgetId={item.id} />}
    </div>
  );
};

export default ItemDetail;
